import { gql } from "@apollo/client";

import type { PromotedGameType } from "@/components/promoted-game-tile";

export interface DataType {
  alsoConsider: PromotedGameType[];
}

export interface VariablesType {
  gameId: string;
  limit?: number;
}

export const QUERY = gql`
  query AlsoConsider($gameId: ID!, $isUser: Boolean!, $limit: Int) {
    alsoConsider(gameId: $gameId, limit: $limit) {
      id
      communityScoreBucket
      communityScorePercentages {
        percentage
        rating
      }
      communityRatingCount
      coupons(limit: 1) {
        id
      }
      gameimageSet {
        id
        imageId
      }
      hasAwards
      hasBookings
      isPromoted
      isSaved @include(if: $isUser)
      location {
        id
        company {
          id
          name
        }
        displayName
      }
      name
      promotedBidId
      slug
    }
  }
`;
